module.exports = __webpack_public_path__ + "img/img_news1.83de60fd.png";